import styled from "styled-components";

export const Wrap = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 18px 16px;
  overflow: hidden;
`;

export const Row = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #000000;
  line-height: 16px;
`;

export const Box = styled.input`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: #008cff;
  margin: 0;
  border-radius: 3.2px;
`;

export const Link = styled.a`
  color: #008cff;
  font-weight: 700;
  text-decoration: none;
`;
